import { put, useHttp } from 'hooks/use-http/useHttp'

export const confirmEmail = async (userId, code: string) => {
  const response = await put(
    `/user/${userId}/confirm-verification`,
    { verificationCode: code },
    { useApiKey: true, dieSilent: false }
  )

  return response
}

export const resendConfirmationCode = async userId => {
  const response = await put(`/user/${userId}/resend-verification`, { useApiKey: true, dieSilent: true })
}

export const useEmailConfirmationAPI = () => {
  return {
    confirmEmail,
    resendConfirmationCode
  } as const
}
